/* eslint-disable */
// biome-ignore-all lint: auto-generated
//
// This file is auto-generated by autoexport.
// Do not modify manually, please do: vp run check.
//
// plugin: I18nFixture
// source: i18n/*/*.json

import type { LibraryType } from "@pdfking/i18n"
import type { EnumUnion } from "@pdfking/structs"
import { LibraryFromJson } from "@pdfking/i18n"

const raw: LibraryType<Readonly<{
  trackers_desc: EnumUnion<{
    UPLOAD: { task_done: unknown; task_total: unknown; done: unknown; total: unknown }
    DOWNLOAD: { task_done: unknown; task_total: unknown; done: unknown; total: unknown }
    COMPRESS: { done: unknown; total: unknown }
    FETCH: { done: unknown; total: unknown }
    JSON_FILE: { done: unknown; total: unknown }
    PLOT_PDF: { done: unknown; total: unknown }
    MERGE_PDF: { done: unknown; total: unknown }
    SPLIT_PDF: { done: unknown; total: unknown }
    PARSE_PDF: { done: unknown; total: unknown }
    RASTERIZE_PDF: { done: unknown; total: unknown }
    GENERATE_FILE: { done: unknown; total: unknown }
  }>
  trackers: EnumUnion<{
    UPLOAD: undefined
    DOWNLOAD: undefined
    COMPRESS: undefined
    FETCH: undefined
    JSON_FILE: undefined
    PLOT_PDF: undefined
    MERGE_PDF: undefined
    SPLIT_PDF: undefined
    PARSE_PDF: undefined
    RASTERIZE_PDF: undefined
    GENERATE_FILE: undefined
  }>
}>, "en" | "fr" | "it"> = {
  trackers_desc: {
    en: () => import("../i18n/trackers_desc/en.json"),
    fr: () => import("../i18n/trackers_desc/fr.json"),
    it: () => import("../i18n/trackers_desc/it.json"),
  },
  trackers: {
    en: () => import("../i18n/trackers/en.json"),
    fr: () => import("../i18n/trackers/fr.json"),
    it: () => import("../i18n/trackers/it.json"),
  },
} as const

export const { trackers_desc, trackers } = LibraryFromJson(raw)
